/**
 * 개발 도구 — 일일 점검 (/adm/dev/daily-check)
 * ($j.Pages.Admin.DailyCheck / body data-page-name="DailyCheck")
 *
 * 주 단위 점검 결과 달력 + 날짜별 상세(본문·원문) + [지금 점검] 실행·진행 폴링.
 */
let curWeek = '';        // 보고 있는 주(월요일)
let curDays = [];
let pollTimer = null;

export default class DailyCheck {
    initialize() {
        loadWeek('');

        $('#btnPrevWeek').on('click', () => loadWeek($('#btnPrevWeek').data('go')));
        $('#btnNextWeek').on('click', () => loadWeek($('#btnNextWeek').data('go')));
        $('#btnThisWeek').on('click', () => loadWeek(''));
        $('#btnRun').on('click', onClickRun);

        $(document).on('click', '.dc-day:not(.is-empty)', function () {
            $('.dc-day').removeClass('is-active');
            $(this).addClass('is-active');
            openDetail($(this).data('num'));
        });

        $('#btnToggleMd').on('click', () => $('#detailMd').toggle());
        $('#btnToggleRaw').on('click', () => $('#detailRaw').toggle());
    }
}

/* ── 주간 목록 ───────────────────────────────── */

function loadWeek(week) {
    $.post('/adm/ajax/dev/daily-check/list', { week: week }, function (res) {
        if (!res.result) return;

        curWeek = res.week.start;
        curDays = res.days;

        $('#weekLabel').text(res.week.label + (res.week.current ? ' (이번 주)' : ''));
        $('#btnPrevWeek').data('go', res.week.prev);
        $('#btnNextWeek').data('go', res.week.next);
        $('#btnNextWeek').prop('disabled', res.week.current);

        renderDays(res.days, res.labels);
        renderWeekIssues(res.issues);
        applyJob(res.job);

        // 가장 최근 리포트를 기본으로 펼친다
        const last = [...res.days].reverse().find(d => d.report);
        if (last) {
            $('.dc-day[data-num="' + last.report.num + '"]').addClass('is-active');
            openDetail(last.report.num);
        } else {
            $('#detailTitle').text('리포트 상세');
            $('#detailBody').html('<span class="dc-muted">이 주에는 점검 기록이 없습니다.</span>');
            $('#detailMd,#detailRaw').hide().empty();
        }
    });
}

function renderDays(days, labels) {
    const html = days.map(function (d) {
        const md = d.date.substring(5).replace('-', '/');
        const dowCls = d.dow === '일' ? 'dc-day-sun' : (d.dow === '토' ? 'dc-day-sat' : '');

        if (!d.report) {
            return `<div class="dc-day is-empty">
                        <div class="dc-day-head"><span class="dc-day-date ${dowCls}">${md} (${d.dow})</span></div>
                        <div class="dc-muted dc-day-empty">${d.future ? '' : '기록 없음'}</div>
                    </div>`;
        }

        const r = d.report;
        const checks = (r.checks || []).map(c =>
            `<div class="dc-check"><span class="dc-dot ${dotClass(c.result)}"></span>${escapeHtml(labels[c.key] || c.key)}</div>`
        ).join('');
        const issueCnt = (r.issues || []).length;

        return `<div class="dc-day" data-num="${r.num}">
                    <div class="dc-day-head">
                        <span class="dc-day-date ${dowCls}">${md} (${d.dow})</span>
                        <span class="st ${r.result === 'ISSUE' ? 'st-issue' : 'st-ok'}">${r.result === 'ISSUE' ? '이상' : '정상'}</span>
                    </div>
                    <div class="dc-checks">${checks}</div>
                    ${issueCnt ? `<div class="dc-day-issues">이슈 ${issueCnt}건</div>` : ''}
                    ${d.runs > 1 ? `<div class="dc-day-runs">그날 ${d.runs}회 실행</div>` : ''}
                </div>`;
    }).join('');

    $('#days').html(html);
}

function renderWeekIssues(issues) {
    $('#issueCount').text(issues.length ? issues.length + '종' : '');

    if (!issues.length) {
        $('#weekIssues').html('<span class="dc-muted">이번 주 잡힌 이슈가 없습니다.</span>');
        return;
    }

    $('#weekIssues').html(issues.map(function (it) {
        return `<div class="dc-issue dc-issue-${it.severity || 'low'}">
                    <div class="dc-issue-title">${sevBadge(it.severity)} ${escapeHtml(it.title)}</div>
                    <div class="dc-issue-meta">
                        ${it.days}일 발생 · 총 ${it.total}건
                        ${it.hosts && it.hosts.length ? ' · ' + escapeHtml(it.hosts.join(', ')) : ''}
                        · 최근 ${it.last}
                    </div>
                    ${it.cause ? `<div class="dc-issue-row"><b>원인 추정</b><span>${escapeHtml(it.cause)}</span></div>` : ''}
                    ${it.fix ? `<div class="dc-issue-row"><b>수정 제안</b><span>${escapeHtml(it.fix)}</span></div>` : ''}
                    ${it.files && it.files.length ? `<div class="dc-issue-row dc-files"><b>관련 파일</b><span>${it.files.map(f => `<code>${escapeHtml(f)}</code>`).join('')}</span></div>` : ''}
                </div>`;
    }).join(''));
}

/* ── 상세 ────────────────────────────────────── */

function openDetail(num) {
    $.post('/adm/ajax/dev/daily-check/detail', { num: num }, function (res) {
        if (!res.result) return;
        const r = res.report;

        $('#detailTitle').html(
            `${r.check_date} 리포트 <span class="st ${r.result === 'ISSUE' ? 'st-issue' : 'st-ok'}">${r.result === 'ISSUE' ? '이상' : '정상'}</span>
             <small class="text-muted ml-2">${r.source === 'manual' ? '수동' : '스케줄'} · ${r.finished_at || r.created_at}</small>`
        );

        const checks = (r.checks || []).map(c =>
            `<div class="dc-detail-check">
                <div class="lbl"><span class="dc-dot dc-dot-inline ${dotClass(c.result)}"></span>${escapeHtml(c.label)}</div>
                <div class="dtl">${escapeHtml(c.detail || '-')}</div>
             </div>`
        ).join('');

        const issues = (r.issues || []).length
            ? r.issues.map(it =>
                `<div class="dc-issue dc-issue-${it.severity || 'low'}">
                    <div class="dc-issue-title">${sevBadge(it.severity)} ${escapeHtml(it.title || '')}</div>
                    <div class="dc-issue-meta">${it.count || 1}건${it.hosts && it.hosts.length ? ' · ' + escapeHtml(it.hosts.join(', ')) : ''}</div>
                    ${it.cause ? `<div class="dc-issue-row"><b>원인 추정</b><span>${escapeHtml(it.cause)}</span></div>` : ''}
                    ${it.fix ? `<div class="dc-issue-row"><b>수정 제안</b><span>${escapeHtml(it.fix)}</span></div>` : ''}
                    ${it.files && it.files.length ? `<div class="dc-issue-row dc-files"><b>관련 파일</b><span>${it.files.map(f => `<code>${escapeHtml(f)}</code>`).join('')}</span></div>` : ''}
                    ${it.samples && it.samples.length ? `<div class="dc-samples">${escapeHtml(it.samples.join('\n'))}</div>` : ''}
                 </div>`
              ).join('')
            : '<div class="dc-muted">잡힌 이슈 없음 — 전 항목 정상입니다.</div>';

        $('#detailBody').html(
            `<div class="dc-detail-summary">${escapeHtml(r.summary || '')}</div>
             <div class="dc-detail-checks">${checks}</div>
             ${issues}`
        );

        $('#detailMd').html(r.body || '<span class="dc-muted">본문 없음</span>').hide();
        $('#detailRaw').text(r.raw_txt || '(수집 원문 없음)').hide();
    });
}

/* ── 실행 ────────────────────────────────────── */

function onClickRun() {
    $('#btnRun').prop('disabled', true);
    $.post('/adm/ajax/dev/daily-check/run', {}, function (res) {
        if (!res.result && !res.job) {
            alert(res.message || '요청에 실패했습니다.');
            $('#btnRun').prop('disabled', false);
            return;
        }
        applyJob(res.job);
        // 이미 돌고 있어서 새로 안 받아준 경우 — 왜 안 눌리는지는 알려준다
        if (!res.result && res.message) {
            $('#runState').append(' <span class="text-muted">' + escapeHtml(res.message) + '</span>');
        }
        startPoll();
    });
}

/** job 상태를 버튼/문구에 반영. 진행 중이면 폴링을 건다 */
function applyJob(job) {
    if (!job) {
        $('#runState').text('');
        $('#btnRun').prop('disabled', false);
        return;
    }

    const st = parseInt(job.status, 10);
    if (st === 0) {
        $('#runState').html('<span class="st st-run">대기</span> ops 머신이 집어가길 기다리는 중…');
        $('#btnRun').prop('disabled', true);
        startPoll();
    } else if (st === 1) {
        $('#runState').html('<span class="st st-run">실행중</span> 수집·분석 중입니다 (2~3분)…');
        $('#btnRun').prop('disabled', true);
        startPoll();
    } else if (st === 9) {
        $('#runState').html('<span class="st st-issue">실패</span> ' + escapeHtml(job.message || ''));
        $('#btnRun').prop('disabled', false);
    } else {
        $('#runState').html('<span class="text-muted">최근 실행 ' + (job.finished_at || '') + '</span>');
        $('#btnRun').prop('disabled', false);
    }
}

function startPoll() {
    if (pollTimer) return;
    pollTimer = setInterval(function () {
        $.post('/adm/ajax/dev/daily-check/job', {}, function (res) {
            const st = res.job ? parseInt(res.job.status, 10) : null;
            if (st === 0 || st === 1) { applyJob(res.job); return; }

            clearInterval(pollTimer);
            pollTimer = null;
            applyJob(res.job);
            loadWeek(curWeek);   // 완료든 실패든 목록을 다시 읽는다 (늦게 올라온 리포트가 있을 수 있다)
        });
    }, 5000);
}

/* ── 유틸 ────────────────────────────────────── */

function dotClass(result) {
    if (result === 'OK') return 'dc-dot-ok';
    if (result === 'ISSUE') return 'dc-dot-issue';
    return 'dc-dot-unknown';
}

function sevBadge(severity) {
    const map = { high: ['st-issue', '높음'], mid: ['st-run', '보통'], low: ['st-none', '낮음'] };
    const [cls, txt] = map[severity] || map.low;
    return `<span class="st ${cls}">${txt}</span>`;
}

function escapeHtml(str) {
    return String(str == null ? '' : str)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
